<mat-divider></mat-divider>

<div class="py-3">
	<div class="d-flex u-full-width">
		<div class="flex-grow-1">
			<p class="mat-subtitle-1 mb-0 app-shopping-cart-item__title"
						*ngIf="item.article.designation">{{item.article.designation | localize}}</p>
			<p>{{item.article.articleNumber}}</p>

			<p *ngIf="item.article.price">
				<span i18n>Stückpreis</span>: {{item.article.price | currency:'EUR':'symbol':'1.2-2'}}</p>

			<div>
				<mat-form-field appearance="outline" style="width: 5rem">
					<input matInput min="1" type="number" [formControl]="item.quantity" (change)="updateItem.emit()">
				</mat-form-field>

				<button mat-stroked-button color="warn" class="ms-3" (click)="removeItem.emit(item)" i18n>Entfernen</button>
			</div>
		</div>

		<p *ngIf="item.article.price" class="mat-subtitle-1 mb-0 justify-content-end app-shopping-cart-item__title">
			{{(item.article.price * item.quantity.value) |  currency:'EUR':'symbol':'1.2-2' }}</p>
	</div>
</div>
